import React from "react";
import "../styles/MacroRegimePanel.css";    
import "../styles/theme-cpg.css";   
import MarketCoachChat from "./MarketCoachChat";

export default function MarketCoachPage() {
  return (
    <div className="coach-page-wrap">
      <div className="coach-page-header">
      </div>

      <div className="coach-page-content-grid">
        <div className="coach-page-main-card">
          <MarketCoachChat />
        </div>
      </div>
    </div>
  );
}
